<template>
  <el-select v-model="status" placeholder="เลือกสถานะ" clearable>
    <el-option
      v-for="item in statusList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { Option as ElOption, Select as ElSelect } from "element-ui"
import { RefinanceStatus } from "../RefinanceStatus"

export default {
  components: {
    ElOption,
    ElSelect,
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    hideItem: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    status: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    statusList() {
      return Object.keys(RefinanceStatus)
        .map((value) => ({
          value,
          label: RefinanceStatus[value],
        }))
        .filter((item) => !this.hideItem || !this.hideItem(item.value))
    },
  },
}
</script>
